module.exports = __webpack_public_path__ + "img/fleet-contactus-hero.jpg";